import * as authApi from '@/services/authApi';
import { clearPendingPassword } from '@/utils/pendingPassword';

/** ログイン後の戻り先。アプリ内のパスだけ許す（外部 URL や //host への open redirect を防ぐ。spec §3.5） */
export const safeReturnPath = (from: unknown): string =>
  typeof from === 'string' && from.startsWith('/') && !from.startsWith('//') ? from : '/';

/**
 * ログアウト。サーバ側で refresh token を失効させ（cookie も消える）、端末側の保存を消す。
 * サーバ側が失敗したら false（呼出側はエラー表示して留まる。消したふりをすると cookie で再ログインされる）。
 */
export const performLogout = async (): Promise<boolean> => {
  try {
    await authApi.logout();
  } catch {
    // サーバ側で失効できなかった（通信失敗・429 など）。HttpOnly cookie が残るので「ログアウト完了」にはしない
    return false;
  }
  window.localStorage.clear();
  // メモリに残っている自動ログイン用パスワードも一緒に消す（取り出されないまま居座らせない）
  clearPendingPassword();
  return true;
};
